export class HttpError {

    constructor(public OriginalError?: any, public FriendlyTitle?: string, public FriendlyMessage?: string) {

    }

}
